"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_jss_1 = __importDefault(require("react-jss"));

var BurnerProvider_1 = require("../BurnerProvider");

var styles = function styles(theme) {
  return {
    header: {
      display: 'flex',
      color: 'white',
      height: 64,
      alignItems: 'center'
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    title: {
      fontSize: 24,
      fontFamily: theme.titleFont
    },
    subtitle: {
      fontSize: 12
    },
    spacer: {
      flex: '1 0'
    },
    headerAccount: {
      fontSize: 14,
      color: 'rgba(255, 255, 255, 0.7)'
    }
  };
};

var Header = function Header(_a) {
  var accounts = _a.accounts,
      title = _a.title,
      classes = _a.classes,
      actions = _a.actions;
  return react_1.default.createElement("header", {
    className: classes.header
  }, react_1.default.createElement("div", {
    className: classes.titleContainer
  }, react_1.default.createElement("div", {
    className: classes.title
  }, title), title !== 'Burner Wallet' && react_1.default.createElement("div", {
    className: classes.subtitle
  }, "Powered by Burner Wallet")), react_1.default.createElement("div", {
    className: classes.spacer
  }), react_1.default.createElement("div", {
    className: classes.headerAccount,
    onClick: function onClick() {
      return actions.navigateTo('/receive');
    }
  }, accounts.length > 0 && accounts[0].substr(2, 8)));
};

Header.defaultProps = {
  title: 'Burner Wallet'
};
exports.default = react_jss_1.default(styles)(BurnerProvider_1.withBurner(Header));